import React, { useEffect, useState } from "react";
import classes from "./About.module.css";
import Header from "../../stories/Header";
import Footer from "../../stories/Footer";
import MainCard from "../../stories/MainCard";
import { Row, Col, Container } from "react-bootstrap";
import Button from "../../stories/Button/Button";
import { CardDemoImg } from "../../constant/imagePath";
import HeroSection from "../../stories/HeroSection";
import { BaseURL, imageUrl } from "../../config/apiUrl";
import { Get } from "../../Axios/AxiosFunctions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveLocation } from "../../redux/common/commonSlice";

const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const [pageData, setPageData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // getData
  const getData = async () => {
    const url = BaseURL(`cms/pages/all?pages=about_us`);
    setIsLoading(true);
    const response = await Get(url, "", false, true);
    setIsLoading(false);

    if (response !== undefined) {
      setPageData(response?.data?.data?.pages);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Header />
      <HeroSection
        heading={pageData?.heading}
        text={
          pageData?.description ||
          "Create and print your own custom trading cards and card games!"
        }
        bgImage={imageUrl(pageData?.bg_image)}
        foregroungImage={imageUrl(pageData?.cover_image)}
      />

      {/* start Second section */}
      {/* <section>
        <Container className={classes.container}>
          <Row className={classes.secondSec_row}>
            <Col lg={3}>
              <div className={classes.secondSec_col}>
                <img src={CardDemoImg} alt="CardDemoImg" />
                <h6>Access More</h6>
                <p>Pursue passions. Get things done.</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className={classes.secondSec_col}>
                <img src={CardDemoImg} alt="CardDemoImg" />
                <h6>Access More</h6>
                <p>Pursue passions. Get things done.</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className={classes.secondSec_col}>
                <img src={CardDemoImg} alt="CardDemoImg" />
                <h6>Access More</h6>
                <p>Pursue passions. Get things done.</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className={classes.secondSec_col}>
                <img src={CardDemoImg} alt="CardDemoImg" />
                <h6>Access More</h6>
                <p>Pursue passions. Get things done.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* end Second section */}

      {/* start third section */}
      <section>
        <Container fluid className={classes.container}>
          <Row className="align-items-center mt-5">
            <Col lg={6}>
              <div className={classes.third_col1}>
                <img
                  src={imageUrl(pageData?.section1_image1)}
                  alt="CardDemoImg"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className={classes.third_col2}>
                <h2>{pageData?.section1_heading1}</h2>
                <p>{pageData?.section1_description1}</p>
                <h2>{pageData?.section1_heading2}</h2>
                <p>{pageData?.section1_description2}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* end third section */}

      {/* start fourth section */}
      <section>
        <Container fluid className={classes.container}>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className={classes.third_col2}>
                <h2>{pageData?.section2_heading}</h2>
                <p>{pageData?.section2_description}</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className={classes.third_col1}>
                <img
                  src={imageUrl(pageData?.section2_image)}
                  alt="CardDemoImg"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* end fourth section */}
      <Footer />
    </>
  );
};

export default Index;
